import { createFileRoute } from '@tanstack/react-router';

/** List lives in the layout; this index only marks `/automations`. */
export const Route = createFileRoute('/_app/automations/')({
  component: () => null,
});
